import * as React from 'react';

import { IDocument,
  IOrderQuantities_Addresses,
  IUserData } from '../../../../infrastructure/interfaces';
import Button from '../../../Button';
import { IModalProps,
  Modal } from '../../../Modal';
import ShippingInfoInteractiveForm from './ShippingInfoInteractiveForm';

export interface IOrderPrintsProps extends IModalProps {
  state: any;
  document: IDocument | null;
  comments: string;
  orderQuantityAddressPairs: IOrderQuantities_Addresses[];
  selectedOrderQuantityAddressPair: IOrderQuantities_Addresses;
  orderQuantityAddressPairIndex: number;
  userData:IUserData;
  onPlaceOrder(document: any, userID: string): void;
  onSaveOrderQuantityAddressPair(orderQuantityAddressPair: IOrderQuantities_Addresses): void;
  onStartNewOrderQuantityAddressPair(): void;
  onSelectedEditOrderQuantityAddressPair(itemIndex: number): void;
  onSelectedDeleteOrderQuantityAddressPair(itemIndex: number): void;
  onFieldChange(e: any): void;
  onDocumentNameFieldChange(e: any): void;
  onOrderCommentsFieldChange(e: any): void;
}
const isAddressQuantityPairingValid = (pairing: IOrderQuantities_Addresses): boolean => {
  return (
    (pairing.orderQuantity > 0)
    && (pairing.address.shipName.replace(/ /g, "").length > 0)
    && (pairing.address.shipAddress1.replace(/ /g, "").length > 0)
    && (pairing.address.shipCity.replace(/ /g, "").length > 0)
    && (pairing.address.shipState.replace(/ /g, "").length > 0)
    && (pairing.address.shipPostalCode.replace(/ /g, "").length > 0)
    && (pairing.address.divisionId.replace(/ /g, "").length > 0)
  );
}

const ShippingInfoInteractiveModal = ({
  show,
  document,
  comments,
  userData,
  onClose,
  state,
  onFieldChange,
  onPlaceOrder,
  onDocumentNameFieldChange,
  onOrderCommentsFieldChange,
  orderQuantityAddressPairs,
  orderQuantityAddressPairIndex,
  onSaveOrderQuantityAddressPair,
  onStartNewOrderQuantityAddressPair,
  onSelectedEditOrderQuantityAddressPair,
  onSelectedDeleteOrderQuantityAddressPair,
  selectedOrderQuantityAddressPair
}: IOrderPrintsProps) => {

  const isValidAddressQuantityPairing = isAddressQuantityPairingValid(selectedOrderQuantityAddressPair)
  const isEditingAnAddress = (orderQuantityAddressPairIndex >= 0);
  const allAddressesAreValid = (orderQuantityAddressPairs.filter((pairing) => (
    isAddressQuantityPairingValid(pairing)
  )).length == orderQuantityAddressPairs.length);

  return (
    <Modal show={show}
      onClose={onClose}
      className="modal-shipping"
    >
      <Modal.Header>
        <Modal.Title>
          <h5>Send This Order to 1 or More Addresses</h5>
        </Modal.Title>
        <Button bsClass="close" onClick={onClose}></Button>
      </Modal.Header>
      <Modal.Body>
        <ShippingInfoInteractiveForm
          onFieldChange={onFieldChange}
          onDocumentNameFieldChange={onDocumentNameFieldChange}
          onOrderCommentsFieldChange={onOrderCommentsFieldChange}
          onSelectedEditOrderQuantityAddressPair={onSelectedEditOrderQuantityAddressPair}
          onSelectedDeleteOrderQuantityAddressPair={onSelectedDeleteOrderQuantityAddressPair}
          selectedOrderQuantityAddressPair={selectedOrderQuantityAddressPair}
          orderQuantityAddressPairIndex={orderQuantityAddressPairIndex}
          document={state.editedDocument}
          comments={comments}
          orderQuantityAddressPairs={orderQuantityAddressPairs}
          statesList={state.statesList}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          bsClass="cancel"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          bsClass="more-green"
          disabled={!isValidAddressQuantityPairing}
          onClick={() => {
            isEditingAnAddress
            ? onSaveOrderQuantityAddressPair(selectedOrderQuantityAddressPair)
            : onStartNewOrderQuantityAddressPair()
          }}
        >
          {isEditingAnAddress ? "Save Address" : "Add Another Address"}
        </Button>
        <Button
          bsClass="more-green"
          disabled={!allAddressesAreValid || isEditingAnAddress}
          onClick={() => {
            onPlaceOrder(document,
              userData.id)
          }}
        >
          Submit Order
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShippingInfoInteractiveModal;



// WEBPACK FOOTER //
// ./src/components/Modals/OrderPrintsModal/Components/ShippingInfoInteractiveModal.tsx